import { render } from "./socket.vue?vue&type=template&id=f9f3c8da&scoped=true"
import script from "./socket.vue?vue&type=script&lang=js"
export * from "./socket.vue?vue&type=script&lang=js"

import "./socket.vue?vue&type=style&index=0&id=f9f3c8da&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f3c8da"]])

export default __exports__